
import { z } from "zod";

export const TicketStatusValues = ["TRIAGE", "OPEN", "RESOLVED", "CANCELED"] as const;
export const TicketStatusSchema = z.enum(TicketStatusValues);
export const TicketStatus = TicketStatusSchema.enum;
export type TicketStatus = (typeof TicketStatusValues)[number];
export const TicketStatusDisplayNames = { "TRIAGE": "Triage",
"OPEN": "Open",
"RESOLVED": "Resolved",
"CANCELED": "Canceled", } satisfies Record<TicketStatus, string>;
